import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import WaringSvg from 'images/v5/icons/badge-warning.svg';
import Accordion from 'layout/atoms/Accordion/Accordion';
import Button from 'layout/atoms/Button/Button';
import Card from 'layout/atoms/Card/Card';
import InputNumber from 'layout/atoms/InputNumber';
import TableGrid, { Body, Cell, Head, Row } from 'layout/atoms/TableGrid/TableGrid';
import { openModal } from 'store/layoutSlice';
import { updateComponentVariantPrice, updateStoreComponentVariantPrice, } from 'store/specificationComponentsCostsSlice';
import styles from './ComponentCostsCard.module.scss';
function ComponentCostsCard({ component, componentCosts, production }) {
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateStoreComponentVariantPrice({ price: value, productVariantSnapshotId: name }));
        dispatch(updateComponentVariantPrice({ price: parseFloat(value), productVariantSnapshotId: name }));
    };
    const componentHeader = (component) => {
        return (React.createElement("div", { className: styles.wrap },
            React.createElement("p", null, component.name),
            React.createElement("p", null, t('product_variant', { count: (componentCosts === null || componentCosts === void 0 ? void 0 : componentCosts.length) || 0 }))));
    };
    const columns = [
        ['100px', '1fr'],
        ...(component.productCategory.variantHasSize ? [['80px', '1fr']] : []),
        ['150px', '2fr'],
    ];
    return (React.createElement(Card, { size: "xs" }, componentCosts && componentCosts.length === 0 ? (componentHeader(component)) : (React.createElement(Accordion, { key: component.id, header: componentHeader(component) },
        React.createElement("div", { className: styles.details },
            React.createElement(TableGrid, { columns: columns },
                React.createElement(Head, null,
                    React.createElement(Row, { head: true }, componentCosts && (React.createElement(React.Fragment, null,
                        React.createElement(Cell, null, t('color_capitalize')),
                        component.productCategory.variantHasSize && (React.createElement(Cell, null, t('size_capitalize'))),
                        React.createElement(Cell, { align: "right" }, t('price_capitalize')))))),
                React.createElement(Body, null, componentCosts &&
                    componentCosts.map((variant) => {
                        var _a, _b;
                        return (React.createElement(Row, { key: variant.id },
                            React.createElement(Cell, null, variant.color),
                            component.productCategory.variantHasSize && React.createElement(Cell, null, variant === null || variant === void 0 ? void 0 : variant.size),
                            React.createElement(Cell, { align: "right" },
                                (((_a = variant === null || variant === void 0 ? void 0 : variant.productVariant.currentPrice) === null || _a === void 0 ? void 0 : _a.price) !== (variant === null || variant === void 0 ? void 0 : variant.price) ||
                                    (variant === null || variant === void 0 ? void 0 : variant.productVariant.currentPrice.currency.isoCode) !==
                                        (variant === null || variant === void 0 ? void 0 : variant.currency.isoCode)) &&
                                    !(variant.price === null || variant.currency === null) && (React.createElement(Button, { size: "xs", shape: "rounded", color: "notice", leftIcon: React.createElement(WaringSvg, null), onClick: () => {
                                        var _a, _b;
                                        return dispatch(openModal({
                                            name: 'componentCostsPriceDiff',
                                            data: {
                                                variantId: variant === null || variant === void 0 ? void 0 : variant.id,
                                                productVariantId: (_a = variant === null || variant === void 0 ? void 0 : variant.productVariant) === null || _a === void 0 ? void 0 : _a.id,
                                                price: (variant === null || variant === void 0 ? void 0 : variant.price) || 0,
                                                currencyId: (_b = variant === null || variant === void 0 ? void 0 : variant.currency) === null || _b === void 0 ? void 0 : _b.id,
                                            },
                                        }));
                                    }, title: t('details') })),
                                React.createElement(InputNumber, { name: variant.id, value: (variant === null || variant === void 0 ? void 0 : variant.price) || 0, suffix: (_b = variant === null || variant === void 0 ? void 0 : variant.currency) === null || _b === void 0 ? void 0 : _b.isoCode.toUpperCase(), onChange: handleInputChange, disabled: production, decimal: 2 }))));
                    }))))))));
}
export default ComponentCostsCard;
